import React from 'react';
import Svg, {Path} from 'react-native-svg';

export const NovaAIChatBotIcon = () => (
  <Svg
    width="138"
    height="138"
    viewBox="0 0 138 138"
    fill="none">
    <Path
      d="M0 14C0 6.26801 6.26801 0 14 0H124C131.732 0 138 6.26801 138 14V124C138 131.732 131.732 138 124 138H14C6.26801 138 0 131.732 0 124V14Z"
      fill="#81B7DE"
      fillOpacity="0.12"
    />
    <Path
      d="M69 46.5V31.5H54"
      stroke="#2B78CA"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M80.25 65.25V72.75"
      stroke="#2B78CA"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M31.5 69H39"
      stroke="#2B78CA"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M99 69H106.5"
      stroke="#2B78CA"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M99 84C99 85.9891 98.2098 87.8968 96.8033 89.3033C95.3968 90.7098 93.4891 91.5 91.5 91.5H57.105C55.116 91.5004 53.2087 92.2909 51.8025 93.6975L43.545 101.955C43.1726 102.327 42.6983 102.581 42.1818 102.684C41.6654 102.786 41.1301 102.733 40.6437 102.532C40.1572 102.331 39.7414 101.989 39.4488 101.552C39.1563 101.114 39.0001 100.599 39 100.073V54C39 52.0109 39.7902 50.1032 41.1967 48.6967C42.6032 47.2902 44.5109 46.5 46.5 46.5H91.5C93.4891 46.5 95.3968 47.2902 96.8033 48.6967C98.2098 50.1032 99 52.0109 99 54V84Z"
      stroke="#2B78CA"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M57.75 65.25V72.75"
      stroke="#2B78CA"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
